import axios from 'axios';

// API base URL - points to local backend
const API_BASE_URL = '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request interceptor (for adding auth tokens later)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor (for handling errors)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Employee API
export const employeeAPI = {
  getAll: (params) => api.get('/employees', { params }),
  getById: (id) => api.get(`/employees/${id}`),
  getBySlug: (slug) => api.get(`/employees/${slug}`),
  create: (data) => api.post('/admin/employees', data),
  update: (id, data) => api.put(`/admin/employees/${id}`, data),
  delete: (id) => api.delete(`/admin/employees/${id}`),
};

// Content API
export const contentAPI = {
  getAll: (params) => api.get('/content', { params }),
  getById: (id) => api.get(`/content/${id}`),
  create: (data) => api.post('/content', data),
  update: (id, data) => api.put(`/content/${id}`, data),
  delete: (id) => api.delete(`/content/${id}`),
  assign: (contentId, employeeId) => api.post(`/content/${contentId}/assign`, { employee_id: employeeId }),
};

// Leads API
export const leadsAPI = {
  getAll: (params) => api.get('/leads/admin/all', { params }),
  getByEmployee: (empId) => api.get(`/leads/employee/${empId}`),
  updateStatus: (id, status) => api.put(`/leads/${id}/status`, { status }),
  getStats: (params) => api.get('/leads/admin/stats', { params }),
};

// Analytics API
export const analyticsAPI = {
  getOverview: (days = 30) => api.get(`/analytics/admin/overview?days=${days}`),
  getByEmployee: (empId, days = 30) => api.get(`/analytics/employee/${empId}?days=${days}`),
  getContentPerformance: (days = 30) => api.get(`/analytics/admin/content-performance?days=${days}`),
};

// Admin API
export const adminAPI = {
  getDashboard: (days = 30) => api.get(`/admin/dashboard?days=${days}`),
  getEmployees: (params) => api.get('/admin/employees', { params }),
  getContent: (params) => api.get('/admin/content', { params }),
};

export default api;